import React from 'react';

import { userHasRole } from '../../services/role';

const CheckUserRole = ({ children, role }) => {
    /*if (!userHasRole(role)) return <React.Fragment />;*/
    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
};

export { CheckUserRole };
